import {
  GetDocumentSettingsResponseDto,
  InformationForDocumentResponseDto,
} from '@tiendanube/common';
import './DocumentPreview.scss';
import { useResponsive } from 'commons/components';
import { DocumentType } from 'domains/FulfillmentOrders/pages/PrintDocumentPage/constants';
import GeneralDocumentPreviewFields from './GeneralDocumentPreviewFields';

interface DocumentPreviewProps {
  type: DocumentType;
  information: InformationForDocumentResponseDto[];
  settings: GetDocumentSettingsResponseDto;
  locationId: string;
  hasOca?: boolean;
}

function DocumentPreview({
  type,
  information,
  settings,
  locationId,
  hasOca = false,
}: Readonly<DocumentPreviewProps>) {
  const { isMobile } = useResponsive();
  const hasEnhancedLayout =
    (type === DocumentType.SHIPPING_DOCUMENT ||
      (type === DocumentType.LABEL && hasOca)) &&
    (settings.showCheckboxPicking || settings.showProductImage);

  return (
    <>
      {information
        .filter(
          ({ fulfillmentOrder }) =>
            !locationId || fulfillmentOrder.assignedLocation.id === locationId,
        )
        .map(({ order, fulfillmentOrder, store }) => (
          <div
            key={fulfillmentOrder.number + order.number}
            className={`stratus--order-document ${type}${
              isMobile ? '-mobile' : ''
            } ${hasEnhancedLayout ? 'enhanced-preview' : ''}`}
          >
            <GeneralDocumentPreviewFields
              fulfillmentOrder={fulfillmentOrder}
              order={order}
              settings={settings}
              store={store}
              type={type}
              isOca={hasOca}
            />
          </div>
        ))}
    </>
  );
}

export default DocumentPreview;
